import { OrderedMap } from "immutable";

const LabelMap = OrderedMap;

export default LabelMap;
